export default "__VITE_ASSET__C16EZcQJ__"